import { Component, OnInit } from '@angular/core';
import { ToasterService } from './_services/toaster.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { SeoService } from './_services/seo.service';
import { JsonLdService } from './_services/json-ld.service';
import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'pakmatti.com';
  constructor(
    private toasterService: ToasterService, 
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private seoService: SeoService,
    private jsonLdService: JsonLdService
  ) {}

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      mergeMap(route => route.data)
    ).subscribe(data => {
      if (data && data.seo) {
        this.seoService.updateMetadata(data.seo);
      } else {
        this.seoService.updateMetadata(); // Fallback to defaults
      }

      // Add default Organization schema on every page
      this.jsonLdService.setData(this.jsonLdService.getOrganizationSchema());
    });

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      document.querySelector('html').scrollIntoView({
        behavior: 'smooth'
      });
    });
  }
  Success(title: string, message?: string) {
 this.toasterService.Success(title, message);
  }

  Info(title: string, message?: string) {
 this.toasterService.Info(title, message);
  }

  Warning(title: string, message?: string) {
 this.toasterService.Warning(title, message);
  }

  Error(title: string, message?: string) {
 this.toasterService.Error(title, message);
  }
}
